// libraries.
import { ModelError } from '@store/apiSlices/interfaces/interfaces';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';

// slices.
import { apiPricingPortal } from '@store/apiSlices/apiSlices';

// types.
export interface GetMedianZonesParams {
  latitude: number;
  longitude: number;
  radius?: number;
  country: string;
}

export interface PolygonCoordinate {
  lat: number;
  lng: number;
}

export interface MedianZone {
  name: string;
  label: string;
  lead_in_polygon: number;
  polygon: PolygonCoordinate[];
  polygon_status: number;
}

export interface GetMedianZonesResponse {
  results: MedianZone[];
  status_code: number;
  success: boolean;
}

export const getMedianZonesEndpoints = apiPricingPortal.injectEndpoints({
  endpoints: builder => ({
    getMedianZones: builder.query<MedianZone[], GetMedianZonesParams>({
      query: ({ latitude, longitude, radius = 2000, country }) => {
        return `/get_median_zones?latitude=${latitude}&longitude=${longitude}&radius=${radius}&country=${country}`;
      },
      transformErrorResponse: (error: FetchBaseQueryError) => {
        const modelError: ModelError = {
          errorStatus: error.status,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          messageFromServer: (error.data as any)?.message,
          serviceErrorName: 'getMedianZones',
        };
        return modelError;
      },
      transformResponse: (response: GetMedianZonesResponse) => {
        return response.results;
      },
    }),
  }),
});

export const { useGetMedianZonesQuery } = getMedianZonesEndpoints;
